import React from 'react'
import SimpleHeader from '../layouts/SimpleHeader'
import SideMenu from '../layouts/SideMenu'
import MenuWrap from '../components/BurgerMenu/MenuWrap'

const LoadingPage = () => {
  return (
    <div id="outer-container" style={{ height: '100%' }}>
      <MenuWrap className="sm:hidden">
        <SideMenu isAuthorized={true}></SideMenu>
      </MenuWrap>
      <div id="page-wrap">
        <div className="flex">
          <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
          <div className="w-full">
            <SimpleHeader />

            <div
              className="flex justify-center items-center h-[calc(100vh-74px)]"
              aria-live="polite"
            >
              <div className="grid gap-3 mb-6">
                <div className="spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
@keyframes spin {
  0%   { transform: rotate(0deg); }
  50%  { transform: rotate(180deg) scale(1.05); }
  100% { transform: rotate(360deg); }
}

.spinner {
  width: 72px;
  height: 72px;
  border: 6px solid transparent;
  border-top: 6px solid #FAD170;   /* Indigo */
  border-right: 6px solid #B69C60; /* Emerald */
  border-radius: 50%;
  animation: spin 1.2s ease-in-out infinite;
  margin: auto;
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.3),
              0 0 24px rgba(16, 185, 129, 0.2);
}
`}</style>
    </div>
  )
}

export default LoadingPage

// import React from 'react'
// import SimpleHeader from '../layouts/SimpleHeader'
// import SideMenu from '../layouts/SideMenu'
// import MenuWrap from '../components/BurgerMenu/MenuWrap'
// import Loading from '../assets/loading.gif'

// const LoadingPage = () => {
//   return (
//     <div id="outer-container" style={{ height: '100%' }}>
//       <MenuWrap className="sm:hidden">
//         <SideMenu isAuthorized={true}></SideMenu>
//       </MenuWrap>
//       <div id="page-wrap">
//         <div className="flex">
//           <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
//           <div className="w-full">
//             <SimpleHeader />
//             <div
//               className="flex justify-center items-center h-[calc(100vh-74px)]"
//               aria-live="polite"
//             >
//               <div className="grid gap-3 mb-6">
//                 <img
//                   className="col-span-3 mx-auto w-4/5 h-full"
//                   src={Loading}
//                   alt="Loading"
//                 />
//                 {/* <h3 className='col-span-3 w-full text-forty font-bold text-onTrack-light-purple text-center mx-auto'>Kick back and relax</h3>
//                                 <p className='col-span-3 w-full text-3xl font-light text-[#000000] text-center mx-auto mb-3'>{'We are generating your campaing dashboard.'}</p> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default LoadingPage
